<template>
  <div class="map-wrapper">
    <div id="modalMap"></div>
  </div>
</template>

<script>
export default {
  name: "GoogleMaps",
  props: ['continents', 'countries'],
  data(){
    return{

      options: {
        center: {lat: 0, lng: 0},
        zoom: 0,
        backgroundColor: "transparent",
        styles: [
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#cddddd"
              }
            ]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }, {
            "featureType": "administrative.country",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#c6c9c2"
              }
            ]
          }, {
            "featureType": "all",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }
        ],
        disableDoubleClickZoom: true,
        draggable: false,
        keyboardShortcuts: false,
        disableDefaultUI: true,
        scrollwheel: false
      },
      map: null,
      markersOnMap: [],
    }
  },

  computed: {
    markers() {
      if (this.continents && this.countries) {
        let markers = []
        Object.entries(this.continents).forEach(([continent, countries]) => {
          Object.values(countries).forEach(country => {
            if(this.countries.includes(country.name)) {
              markers.push(country)
            }
          })
        })
        return markers
      }
    }
  },
  methods: {

    addMarkersToMap() {

      this.markers.forEach(marker => {

        const markerOnMap = new google.maps.Marker({
          position: marker.location,
          icon: '/images/map-marker.png',
          map: this.map
        });
        this.markersOnMap.push(markerOnMap)
      })
    },
  },

  mounted() {

    const GoogleMapsLoader = require('google-maps');
    GoogleMapsLoader.KEY = 'AIzaSyAW8Z_p6QW0NfGchaL8rJU6nfkXW8f-Lvk';
    GoogleMapsLoader.load((google)=> {
      if(process.browser) {
        const mapEl = document.getElementById('modalMap')
        this.map = new google.maps.Map(mapEl, this.options);
        if(this.markers) {
          this.addMarkersToMap()
        }
      }
    });
  },
}

</script>

<style>
#modalMap {
  width: 300px;
  height: 300px;
  /* border-radius: 50%; */
  /* -webkit-mask-image: url("/images/circle-mask-xs.svg");
  -webkit-mask-repeat: no-repeat; */
}

.map-wrapper {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// scripts/tj-modal-map.vue